import session from './session'
import {ENDPOINT} from './index'

export default {
  create (data) {
    return session.post(ENDPOINT + '/phone_number/create_phone_number/', data)
  },
  update (data) {
    return session.post(ENDPOINT + '/phone_number/update_phone_number/', data)
  },
  check (data) {
    return session.post(ENDPOINT + '/phone_number/check_phone_number/', data)
  },
  remove (id) {
    return session.post(ENDPOINT + '/phone_number/delete_phone_number/', {id: id})
  },
  get (id) {
    return session.post(ENDPOINT + '/phone_number/get_phone_number/', {id: id})
  },
  filter (filterData, page, pageSize, orderBy = '-id') {
    return session.post(ENDPOINT + '/phone_number/filter_phone_number/', {page: page, page_size: pageSize, filter: filterData, order_by: orderBy})
  },
  getStatisticPhoneNumber (filterData, page, pageSize) {
    return session.post(ENDPOINT + '/phone_number/get_statistic_phone_number/', {page: page, page_size: pageSize, filter: filterData})
  },
  importPhoneNumber (formData) {
    return session.post(ENDPOINT + '/phone_number/import_phone_number/', formData)
  },
  confirmImportPhoneNumber (data) {
    return session.post(ENDPOINT + '/phone_number/confirm_import_phone_number/', data)
  },
  bulkUpdateStatus (orderFilterData, telcoList, status) {
    return session.post(ENDPOINT + '/phone_number/bulk_update_status/', {page: 1, page_size: 1, filter: orderFilterData, status: status, telco_list: telcoList})
  },
  updateListPhoneNumberStatus (idList, statusId, telcoList, markDelete = false) {
    return session.post(ENDPOINT + '/phone_number/update_list_phone_number_status/', {phone_number_id_list: idList, phone_number_status_id: statusId, telco_list: telcoList, mark_delete: markDelete})
  },
  bulkUpdateStatusForTech (filterData, status) {
    return session.post(ENDPOINT + '/phone_number/bulk_update_status_for_tech/', {page: 1, page_size: 1, filter: filterData, status: status})
  },
  updateListPhoneNumberStatusForTech (idList, statusId) {
    return session.post(ENDPOINT + '/phone_number/update_list_phone_number_status_for_tech/', {phone_number_id_list: idList, phone_number_status_id: statusId})
  },
  export (filterData) {
    return session.post(ENDPOINT + '/phone_number/export_phone_number/', filterData)
  },
  filterTechnicalActivity (filterData, page, pageSize, orderBy = '-id') {
    return session.post(ENDPOINT + '/phone_number/filter_phone_number_technical_activity/', {page: page, page_size: pageSize, filter: filterData, order_by: orderBy})
  },
  revert (id) {
    return session.post(ENDPOINT + '/phone_number/revert_phone_number_technical_activity/', {id: id})
  },
  copyPhoneNumber (filterData, page, pageSize, orderBy = '-id') {
    return session.post(ENDPOINT + '/phone_number/copy_phone_number/', {page: page, page_size: pageSize, filter: filterData, order_by: orderBy})
  },
}



// WEBPACK FOOTER //
// ./src/api/phoneNumberApi.js